import React, {Component} from "react";

import {expand, plusCircle} from "../icons";
import List from "./List";
import Chart from "./Chart";
import NotificationCenter from "./NotificationCenter";
import * as templateHelper from "../helper/template"
import SingleMetric from "./SingleMetric";
import VideoList from "./VideoList";
import {IGridConfigItem} from "../../../constants/interfaces";

type Props = {
    templateId: number,
    item: IGridConfigItem,
    updateConfig: Function,
    id: number,
    isEdit?: boolean,
    dashboardId: number | string
}

type State = {
    collapsed: boolean,
    itemOpen: boolean,
    activeType: string | null,
}

class ConfigItem extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        
        this.state = {
            collapsed: true,
            itemOpen: false,
            activeType: null,
        }
        
        this.collapse = this.collapse.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.updateConfig = this.updateConfig.bind(this);
        this.getDefaultTypeConfig = this.getDefaultTypeConfig.bind(this);
        this.openIfDataExists = this.openIfDataExists.bind(this);
    }

    componentDidMount() {
		this.openIfDataExists();
	}

	componentDidUpdate(prevProps: Props) {
        if (prevProps.templateId !== this.props.templateId) {
            this.closeItem();
        }

        if (prevProps.item.cell_content_type !== this.props.item.cell_content_type) {
        	this.openIfDataExists();
		}

        if (prevProps.dashboardId !== this.props.dashboardId) {
            this.openIfDataExists();
        }
    }

	openIfDataExists() {
		const type = this.props.item.cell_content_type;
		if (type) {
			this.setState({
				collapsed: false,
				activeType: type,
				itemOpen: true
			})
		} else {
			this.closeItem();
		}
	}
    
    closeItem() {
        this.setState({
            collapsed: true,
            activeType: null,
            itemOpen: false
        });
    }

    collapse() {
        this.setState({collapsed: !this.state.collapsed})
    }

    getDefaultTypeConfig(type: string) {
        switch (type) {
            case "list":
                return {
                    fields: ["title", "totalPageviews"],
                    sort: 'totalPageviews.desc',
                    cell_content_type: 'list'
                };
            case "video_list":
                return {
                    fields: ["title", "total", "totalWeb", "totalApp"],
                    sort: "total.desc",
                    cell_content_type: "video_list"
                };
            case "chart":
                return {
                    graph_metric: "views",
                    cell_content_type: "chart",
                };
			case "notification_centre": 
				return {
					cell_content_type: "notification_centre"	
				};
            default:
                return {
                    content_type: "pageviews",
                    compared_to: "yesterday",
                    cell_content_type: "metric"
                };
        }
    }
    
    openItem(type: string) {
        this.setState({
            activeType: type,
            itemOpen: true,
        });

        this.props.updateConfig(
          this.props.id,
          {...this.props.item, ...this.getDefaultTypeConfig(type)}
        );
    }
    
    removeItem() {
        this.setState({
            activeType: null,
            itemOpen: false
        });

        this.props.updateConfig(
            this.props.id,
            templateHelper.getTemplateCellDefaultConfiguration(this.props.templateId, this.props.id)
        );
    }

    updateConfig<K extends keyof IGridConfigItem>(
        itemsChanged: K[],
        values: IGridConfigItem[K][]
    ) {
        const partial: Partial<IGridConfigItem> = {};

        itemsChanged.forEach((itemKey, index) => {
            partial[itemKey] = values[index];
        });

        this.props.updateConfig(this.props.id, partial);
    }

    renderOption(type: string, index: number) {
        let optionText = "";
        switch (type) {
            case "list": 
                optionText = "Add list";
                break;
            case "video_list":
                optionText = "Add video list";
                break;
            case "chart":
                optionText = "Add chart";
                break;
            case "notification_centre":
                optionText = "Add notification centre";
                break;
            default:
                optionText = "Add single metric";
        }
        
        return (
            <button key={index} className="btn btn-outline-primary" onClick={() => this.openItem(type)}>
                {plusCircle}
                {optionText}
            </button>
        )
    }

    renderItem() {
        const props = {
            item: this.props.item,
            id: this.props.id,
            updateConfig: this.updateConfig,
            removeItem: this.removeItem,
			isEdit: this.props.isEdit || false
        };

        switch (this.state.activeType) {
            case "list":
                return <List {...props}/>;
            case "video_list":
                return <VideoList {...props}/>
            case "chart":
                return <Chart {...props}/>;
            case "notification_centre":
                return <NotificationCenter {...props}/>
            default:
                return <SingleMetric {...props}/>
        }
    }

    render() {
        return (
            <div className={`config-item ${this.state.collapsed ? "collapsed" : ""} ${(!this.state.collapsed && this.state.itemOpen) ? "pb-5" : ""}`}>
                <div className="config-item__header" onClick={this.collapse}>
                    <p>{this.props.item.label}</p>
                    <span className="expand">
                        {expand}
                    </span>
                </div>
                <div className="config-item__body">
                    {
                        !this.state.itemOpen ? (
                            <div className="config_item__body-btns">
                                { this.props.item.allowed_content_type.map((type, index) =>(
                                    this.renderOption(type, index)
                                ))}
                            </div>
                        ) : (
                            this.renderItem()
                        )
                    }
                </div>
            </div>
        );
    }
}

export default ConfigItem;
